module.exports = __webpack_public_path__ + "img/1_009.afde1d6f.jpg";